import { shrpaApi } from "@/repos/axios";
import type { CustomerSocialMediaSettingsData } from "@/contracts/socialMediaSettings";
import { getCalendarTestMode } from "@logic/calendarTestModeManager";

const basePath = "/social-media-settings";
const getCalendarId = () => getCalendarTestMode();

export default class SocialMediaSettingsRepo {
  static async getSettings(customerId: string): Promise<CustomerSocialMediaSettingsData> {
    const calendarId = getCalendarId();
    const response = await shrpaApi.get(`${basePath}/${encodeURIComponent(customerId)}/${encodeURIComponent(calendarId)}`);
    return response.data as CustomerSocialMediaSettingsData;
  }

  static async updateSettings(settings: CustomerSocialMediaSettingsData): Promise<CustomerSocialMediaSettingsData> {
    if (!settings?.id || !settings?.customerId) throw new Error("settings.id and settings.customerId are required");
    const calendarId = getCalendarId();
    const url = `${basePath}/${encodeURIComponent(settings.customerId)}/${encodeURIComponent(calendarId)}/${encodeURIComponent(settings.id)}`;
    const response = await shrpaApi.put(url, settings);
    return response.data as CustomerSocialMediaSettingsData;
  }

  static async checkForLinkedAccount(customerId: string): Promise<CustomerSocialMediaSettingsData> {
    const calendarId = getCalendarId();
    const url = `${basePath}/${encodeURIComponent(customerId)}/${encodeURIComponent(calendarId)}/check-for-linked-account`;
    const response = await shrpaApi.put(url);
    return response.data as CustomerSocialMediaSettingsData;
  }
}
